export default __webpack_public_path__ + "img/1267daa4d12937ff692ec7bade73d506.png";